import { render } from "./ModalEditPdf.vue?vue&type=template&id=0f838344&scoped=true"
import script from "./ModalEditPdf.vue?vue&type=script&lang=js"
export * from "./ModalEditPdf.vue?vue&type=script&lang=js"

import "./ModalEditPdf.vue?vue&type=style&index=0&id=0f838344&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f838344"]])

export default __exports__